export default __webpack_public_path__ + "static/media/warehouse.233a85d1.jpg";